module.exports = __webpack_public_path__ + "static/sn-logo-full-825f2d975a39d82f3047d99fae9733da.svg";